import { render } from "./configModal.vue?vue&type=template&id=0da6a139&scoped=true"
import script from "./configModal.vue?vue&type=script&lang=js"
export * from "./configModal.vue?vue&type=script&lang=js"

import "./configModal.vue?vue&type=style&index=0&id=0da6a139&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da6a139"]])

export default __exports__